module.exports = __webpack_public_path__ + "img/chevron-up.b1b47cff.svg";